import React from 'react';
import {compose} from 'redux';
import {translate} from 'react-i18next';
import {Form, Input} from 'antd';

import {SPAN_ONE_THIRD, SPAN_TWO_THIRDS} from '../../styles/constants';
import MultilanguageInput from '../multilanguage-input';
import './style.css';

const formItemLayout = {
  labelCol: {span: SPAN_ONE_THIRD},
  wrapperCol: {span: SPAN_TWO_THIRDS},
};

const mapPropsToFields = ({sequenceMapping, cube}) => ({
  name: Form.createFormField({value: sequenceMapping !== null ? sequenceMapping.Name : null}),
  description: Form.createFormField({value: sequenceMapping !== null ? sequenceMapping.Description : null}),
  cubeId: Form.createFormField({value: cube !== null ? cube.Code : null}),
  cubeName: Form.createFormField({value: cube !== null ? cube.labels : null}),
});

const SequenceMappingForm = ({
                           t,
                           form,
                           components
                         }) =>
  <Form>
    <Form.Item label={t('data.sequenceMapping.name.label')} {...formItemLayout}>
      {form.getFieldDecorator('name')(
        <Input
          disabled
          title={form.getFieldValue('name')}
        />
      )}
    </Form.Item>
    <Form.Item label={t('data.sequenceMapping.description.label')} {...formItemLayout}>
      {form.getFieldDecorator('description')(
        <Input
          disabled
          title={form.getFieldValue('description')}
        />
      )}
    </Form.Item>
    <Form.Item label={t('data.sequenceMapping.cube.id.label')} {...formItemLayout}>
      {form.getFieldDecorator('cubeId')(
        <Input
          disabled
          title={form.getFieldValue('cubeId')}
        />
      )}
    </Form.Item>
    <Form.Item label={t('data.sequenceMapping.cube.name.label')} {...formItemLayout}>
      {form.getFieldDecorator('cubeName')(
        <MultilanguageInput
          disabled
        />
      )}
    </Form.Item>
    <Form.Item
      label={t('data.sequenceMapping.components.label')}
      className="sequence-mapping-form__field__components"
      style={{marginBottom: 8, fontWeight:"bold"}}
    >
      <span/>
    </Form.Item>
    <div style={{height: 200}}>
      {(components || []).map((value, index) => 
        <div 
          key={index}  
          style={{fontWeight:"bold"}}        
        >
          {value.Name}
        </div>
      )}
    </div>
  </Form>;

export default compose(
  translate(),
  Form.create({mapPropsToFields})
)(SequenceMappingForm);
